/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGuide.vue?vue&type=template&id=8515cdea&scoped=true"
import script from "./popGuide.vue?vue&type=script&lang=js"
export * from "./popGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8515cdea",
  null
  
)

export default component.exports